// extracted by mini-css-extract-plugin
module.exports = {"md":"RegistrationUserAgreements_md_QB5a3","ios":"RegistrationUserAgreements_ios_3wDJI","footer":"RegistrationUserAgreements_footer_2nEg0"};